module.exports = __webpack_public_path__ + "static/img/hero.4cb2025.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/ComicList/img/header/hero.png
// module id = 496
// module chunks = 0